import { CheckCircle2, Clock, XCircle, FileEdit } from "lucide-react";

const CONFIG = {
  signed: { label: "Подписан", color: "text-blue-700 bg-blue-50 border-blue-200", icon: CheckCircle2 },
  in_progress: { label: "Отправлено на подпись", color: "text-emerald-700 bg-emerald-50 border-emerald-200", icon: Clock },
  rejected: { label: "Отказ в подписи", color: "text-rose-700 bg-rose-50 border-rose-200", icon: XCircle },
  draft: { label: "Черновик", color: "text-slate-600 bg-slate-100 border-slate-200", icon: FileEdit },
};

export function StatusStamp({ status, className = "" }) {
  const cfg = CONFIG[status] || CONFIG.draft;
  const Icon = cfg.icon;
  return (
    <span
      data-testid="status-stamp-badge"
      data-status={status}
      className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full border ${cfg.color} ${className}`}
    >
      <Icon className="w-3.5 h-3.5" /> {cfg.label}
    </span>
  );
}

const STAMP_STYLE = {
  signed: { border: "border-blue-600", bg: "bg-blue-50/60", text: "text-blue-900", header: "ДОКУМЕНТ ПОДПИСАН ЭЛЕКТРОННОЙ ПОДПИСЬЮ" },
  in_progress: { border: "border-emerald-600", bg: "bg-emerald-50/60", text: "text-emerald-900", header: "ОТПРАВЛЕНО НА ПОДПИСЬ" },
  rejected: { border: "border-rose-600", bg: "bg-rose-50/60", text: "text-rose-900", header: "ОТКАЗАНО В ПОДПИСАНИИ ЭЦП" },
};

export function SealStamp({ status, meta = {} }) {
  const s = STAMP_STYLE[status];
  if (!s) return null;
  return (
    <div data-testid="seal-stamp" className={`border-2 border-dashed ${s.border} ${s.bg} ${s.text} rounded-lg p-4 font-mono text-xs space-y-1`}>
      <div className="font-bold tracking-wide mb-1">{s.header}</div>
      {meta.certificate && <div>Сертификат: {meta.certificate}</div>}
      {meta.actor && <div>{status === "rejected" ? "Подписант" : "Ответственный"}: {meta.actor}</div>}
      {meta.timestamp && <div>Дата: {meta.timestamp}</div>}
      {meta.reason && <div>Причина: {meta.reason}</div>}
    </div>
  );
}
